import React from 'react';
import PropTypes from 'prop-types';

import HTMLView from 'Components/HTMLView';
import { Box, Flex, SvgIcon, Text } from 'Components/Base';
import useCompatibleDisplay from 'Util/Hooks/useCompatibleDisplay';

export const ClearLoadingIcon = () => (
  <SvgIcon color={'clear.clearDark'} icon={SvgIcon.ICON_LIST.LOADING} />
);

export const TextTitle = ({ title, ...restProps }) => {
  const { isMobile } = useCompatibleDisplay();
  return (
    <Text
      textStyle={isMobile ? 'subtitle1' : 'heading5'}
      lineHeight={1.5}
      letterSpacing={0.1}
      {...restProps}
    >
      <HTMLView rawContent={title} loadingComponent={() => <ClearLoadingIcon />} />
    </Text>
  );
};

const AttachmentItem = ({ title, ...restProps }) => {
  return (
    <Flex
      alignItems={'center'}
      backgroundColor={'white'}
      justifyContent={'space-between'}
      padding={6}
      style={{ borderRadius: 16, cursor: 'pointer', boxShadow: '0 2px 4px 0px rgba(0, 0, 0, 0.1)' }}
      {...restProps}
    >
      <TextTitle title={title} />
      <Box>
        <SvgIcon icon={SvgIcon.ICON_LIST.ARROW_RIGHT} size={30} />
      </Box>
    </Flex>
  );
};

AttachmentItem.propTypes = { title: PropTypes.string };
TextTitle.propTypes = { title: PropTypes.string };

export default AttachmentItem;
